<script>
  import { Aside } from 'element-ui'
  export default {
    name:'ElAside',
    extends:Aside
  }
</script>
